import { useCallback } from 'react';
import { useTableStore } from './selectTableStore';
import { adminAPI } from 'services/admin';
// import { useNavigate } from 'react-router-dom';

export const useTable = ({ url, listKey }) => {
  const {
    setIsLoading,
    setCount,
    setData,
    selectedItems,
    data,
    setSelectedItemsByListId,
  } = useTableStore();
  // const navigate = useNavigate();

  const getDataTable = useCallback(
    async ({ page = 0, filter = '' } = {}) => {
      setIsLoading(true);
      try {
        const offset = page * 10;
        const path = `${url}${offset}${filter ? `&${filter}` : ''}`;
        const response = await adminAPI.get(path);

        setCount(response.totalItemsCountFiltered);
        setData(response[listKey]);
        return response;
      } catch (error) {
        console.error('Erro ao buscar dados da APIxxxx:', error);
        // navigate('/login');
      } finally {
        setIsLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [listKey, url]
  );

  // Silent data fetching for background polling (doesn't update loading state)
  const getDataTableSilent = useCallback(
    async ({ page = 0, filter = '' } = {}) => {
      try {
        const offset = page * 10;
        const path = `${url}${offset}${filter ? `&${filter}` : ''}`;
        console.log('Series silent fetch:', { path, page, filter });
        const response = await adminAPI.get(path);
        console.log('Series silent fetch result:', {
          itemCount: response[listKey]?.length || 0,
          totalCount: response.totalItemsCountFiltered,
        });
        return response;
      } catch (error) {
        console.error('Error in series silent fetch:', error);
        return null;
      }
    },
    [listKey, url]
  );

  const onChangeSelected = (listId, selected) => {
    const allSelectedData = [
      ...(selectedItems?.[listId] || []),
      ...data,
    ].reduce((acc, currentValue) => {
      if (selected[currentValue.id]) {
        return { ...acc, [currentValue.id]: currentValue };
      }
      return acc;
    }, {});

    setSelectedItemsByListId(listId, Object.values(allSelectedData));
  };

  return {
    onChangeSelected,
    getDataTable,
    getDataTableSilent,
  };
};


